import { OriginalDishCategory } from 'models/entities/original-dish-category';
import { OriginalMenuCategory } from 'models/entities/original-menu-category';
import { RelationshipCollection } from 'models/entities/relationship';

type Data = {
  target: OriginalDishCategory;
  menuCategory: OriginalMenuCategory;
}

type DataToChange = {
  name?: string;
  offMenu?: boolean;
};

class Model {

  readonly target: OriginalDishCategory;
  readonly isNew: boolean;
  readonly inFocus: boolean;
  readonly canDelete: boolean;
  readonly menuCategory: OriginalMenuCategory;

  readonly name: string;
  readonly offMenu: boolean;

  readonly result?: OriginalDishCategory;

  constructor(data: Data) {
    this.target = data.target;
    this.isNew = !data.target.id;
    this.inFocus = false;
    this.canDelete = false;
    this.menuCategory = data.menuCategory;
    this.name = this.target.name;
    this.offMenu = this.target.offMenu;
  }

  focus(): this {
    if (!this.isNew) return this;
    const inFocus = true;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, inFocus });
  }

  async readRelationships(originalId: string): Promise<this> {
    const relationships = await RelationshipCollection.readByOriginalId(originalId, 1);
    const canDelete = !relationships.documents.length;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, canDelete });
  }

  change(data: DataToChange): this {
    const props = { ...this, ...data };
    const result = this.validate(props) ? this.apply(props) : undefined;
    return Object.assign(Object.create(this.constructor.prototype), { ...props, result });
  }

  private validate(data: DataToChange): boolean {
    if (!data.name) return false;
    return true;
  }

  private apply(data: DataToChange): OriginalDishCategory {
    const name = data.name;
    const offMenu = data.offMenu;
    return this.target.edit({ name, offMenu });
  }

  async save(): Promise<this> {
    if (!this.result) throw new Error('invalid result');
    const result = await this.result.save();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

  async delete(): Promise<this> {
    const result = await this.target.delete();
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result });
  }

}

export { Model };